import { render, staticRenderFns } from "./TiposCreditoForm.vue?vue&type=template&id=5255f2b3&scoped=true"
import script from "./TiposCreditoForm.vue?vue&type=script&lang=js"
export * from "./TiposCreditoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255f2b3",
  null
  
)

export default component.exports